"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.TextBlockArticleDefaultProps = exports.TextBlockArticle = void 0;
var _textBlockArticle = _interopRequireDefault(require("./components/text-block-article"));
exports.TextBlockArticle = _textBlockArticle["default"];
var _textBlockArticle2 = _interopRequireDefault(require("./components/text-block-article.props/text-block-article.defaultProps"));
exports.TextBlockArticleDefaultProps = _textBlockArticle2["default"];